export default [
  {
    path: '/metrics/collections',
    name: 'MetricList',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/metrics/MetricList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Coleccción de Métricas'
    }
  },
  {
    path: '/dashboard/default',
    name: 'DefaultDashboardList',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/DefaultDashboardList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard predefinidos'
    }
  },
  {
    path: '/dashboard/favorites',
    name: 'Favorites',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/DefaultDashboardList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard favoritos'
    }
  },
  {
    path: '/dashboard/create',
    name: 'DashboardCreate',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/DashboardCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/dashboard/:id/edit',
    name: 'DashboardUpdate',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/DashboardCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/dashboard/:id/',
    name: 'DashboardRetrieve',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/DashboardCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalles del Dashboard'
    }
  },
  {
    path: '/dashboards',
    name: 'Dashboards',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/dashboards/WelcomeDashboard.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Bienvenida dashboards'
    }
  }
]